
import React from "react";
import ReactDOM from "react-dom";

// Fonts
import "typeface-merriweather";
import "typeface-public-sans";

// App style
import App from "./components/App";

const render = () => {
  return ReactDOM.render(
      <App />,
    document.getElementById("root")
  );
};

render();

if (process.env.NODE_ENV !== "production") {
  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }
}
